import api from 'data/api';

export const loadDataTable = api('POST /api/mobile/performance/grid');
